import { render, staticRenderFns } from "./NumericInput.vue?vue&type=template&id=22520fb7"
import script from "./NumericInput.vue?vue&type=script&lang=js"
export * from "./NumericInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports